module.exports = __webpack_public_path__ + "static/img/notice-icon.c336ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/notice-icon.png
// module id = QR93
// module chunks = 1